import React from 'react'

const LocationMarkIcon = ({ width = '24', height = '25' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.12467 9.77214C6.23579 9.77214 6.33995 9.75464 6.43717 9.71964C6.5344 9.68519 6.62467 9.6263 6.70801 9.54297L9.66634 6.58464C9.81912 6.43186 9.89551 6.23741 9.89551 6.0013C9.89551 5.76519 9.81912 5.5638 9.66634 5.39714C9.49967 5.24436 9.29829 5.16797 9.06217 5.16797C8.82606 5.16797 8.63162 5.24436 8.47884 5.39714L6.12467 7.7513L5.54134 7.16797C5.38856 7.01519 5.19412 6.9388 4.95801 6.9388C4.7219 6.9388 4.52745 7.01519 4.37467 7.16797C4.20801 7.33464 4.12467 7.53602 4.12467 7.77214C4.12467 8.00825 4.20801 8.20269 4.37467 8.35547L5.54134 9.54297C5.62467 9.6263 5.71495 9.68519 5.81217 9.71964C5.9094 9.75464 6.01356 9.77214 6.12467 9.77214ZM6.99967 17.0221C6.88856 17.0221 6.77745 17.0013 6.66634 16.9596C6.55523 16.918 6.45801 16.8624 6.37467 16.793C4.3469 15.0013 2.83301 13.3382 1.83301 11.8038C0.833008 10.2688 0.333008 8.83464 0.333008 7.5013C0.333008 5.41797 1.00329 3.75825 2.34384 2.52214C3.68384 1.28602 5.23579 0.667969 6.99967 0.667969C8.76356 0.667969 10.3155 1.28602 11.6555 2.52214C12.9961 3.75825 13.6663 5.41797 13.6663 7.5013C13.6663 8.83464 13.1663 10.2688 12.1663 11.8038C11.1663 13.3382 9.65245 15.0013 7.62467 16.793C7.54134 16.8624 7.44412 16.918 7.33301 16.9596C7.2219 17.0013 7.11079 17.0221 6.99967 17.0221Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default LocationMarkIcon
